/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SignInMethodEntity } from './SignInMethodEntity';
import {
    SignInMethodEntityFromJSON,
    SignInMethodEntityFromJSONTyped,
    SignInMethodEntityToJSON,
    SignInMethodEntityToJSONTyped,
} from './SignInMethodEntity';

/**
 * 
 * @export
 * @interface UserAuthInfoEntity
 */
export interface UserAuthInfoEntity {
    /**
     * ユーザーID
     * @type {string}
     * @memberof UserAuthInfoEntity
     */
    id: string;
    /**
     * テナントID
     * @type {string}
     * @memberof UserAuthInfoEntity
     */
    tenantId: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof UserAuthInfoEntity
     */
    email: string;
    /**
     * 登録日時（アカウントが作成された日付）
     * @type {number}
     * @memberof UserAuthInfoEntity
     */
    creationTime: number;
    /**
     * 
     * @type {Array<SignInMethodEntity>}
     * @memberof UserAuthInfoEntity
     */
    signInMethods: Array<SignInMethodEntity>;
}

/**
 * Check if a given object implements the UserAuthInfoEntity interface.
 */
export function instanceOfUserAuthInfoEntity(value: object): value is UserAuthInfoEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('signInMethods' in value) || value['signInMethods'] === undefined) return false;
    return true;
}

export function UserAuthInfoEntityFromJSON(json: any): UserAuthInfoEntity {
    return UserAuthInfoEntityFromJSONTyped(json, false);
}

export function UserAuthInfoEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAuthInfoEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tenantId': json['tenantId'],
        'email': json['email'],
        'creationTime': json['creationTime'],
        'signInMethods': ((json['signInMethods'] as Array<any>).map(SignInMethodEntityFromJSON)),
    };
}

export function UserAuthInfoEntityToJSON(json: any): UserAuthInfoEntity {
    return UserAuthInfoEntityToJSONTyped(json, false);
}

export function UserAuthInfoEntityToJSONTyped(value?: UserAuthInfoEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'email': value['email'],
        'creationTime': value['creationTime'],
        'signInMethods': ((value['signInMethods'] as Array<any>).map(SignInMethodEntityToJSON)),
    };
}

